import { AppIdentifier } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED
} from "./constants";

export interface IPayState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
}

export interface IPayAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
}

const INITIAL_STATE: IPayState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: IPayState, action: IPayAction) : IPayState => {
  return {
      ...state,
      isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: IPayState, action: IPayAction) : IPayState => {
  return {
      ...state,
      isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: IPayState, action: IPayAction) : IPayState => {
  return {
      ...state,
      jwt: action.jwt as string,
  }
}

const reducerMap: { [actionType: string]: (state: IPayState, action: IPayAction) => IPayState } = {
  // Pay reducer
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.PAY)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.PAY)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.PAY)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
};

const PayReducer = (state = INITIAL_STATE, action: IPayAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
      return reducerMap[action.type](state, action);
  } else {
      return state;
  }
}

export default PayReducer;
